import React from 'react';
import { Link } from 'react-router-dom';
import QRCodeComponent from './QRCode';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-100 text-gray-700 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <h3 className="text-xl font-bold text-green-700 mb-4">Tacoma Off Market</h3>
            <p className="mb-2">We buy houses fast for cash in Tacoma, WA</p>
            <p className="mb-4">No fees, no repairs, no hassle</p>
            <p>&copy; {currentYear} Tacoma Off Market. All rights reserved.</p>
          </div>
          
          <div className="flex flex-col items-center">
            <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
            <div className="flex flex-col space-y-2">
              <Link to="/" className="hover:text-green-700">Home</Link>
              <Link to="/how-it-works" className="hover:text-green-700">How It Works</Link>
              <Link to="/about" className="hover:text-green-700">About</Link>
              <Link to="/contact" className="hover:text-green-700">Contact</Link>
            </div>
          </div>
          
          <div className="mt-6 md:mt-0">
            <QRCodeComponent url="https://tacomaoffmarket.com" size={120} />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 